import cookie from "@/core/cookie"
import settings from "@/core/settings"

export default function externalIdentification() {
  if (settings && settings.externalIdentifier) {
    return cookie.get(settings.externalIdentifier) || undefined
  }
  return undefined
}
